export default [
  {
    path: '/noValidation',
    name: 'NoValidation',
    component: () => import('../views/noValidation/Index.vue'),
    children: [
      {
        path: 'middlePage',
        name: 'MiddlePage',
        meta: {
          title: '跳转'
        },
        component: () =>
          import('../views/noValidation/middlePage.vue')
      },
      {
        path: 'clear',
        name: 'Clear',
        meta: {
          title: '清除缓存'
        },
        component: () =>
          import('../views/noValidation/clearCache.vue')
      },
      {
        path: 'img',
        name: 'Img',
        meta: {
          title: '图片'
        },
        component: () =>
          import('../views/noValidation/Img.vue')
      }
    ]
  }
]
